import SendMessage from "./components/send-message"
import styles from "./index.module.scss"

const Enterprise = () => {
  return (
    <div className={styles.enterpriseBox}>
      <SendMessage />
    </div>
  )
}

export default Enterprise
